export const _en = {
    id: {
        label: "Index"
    },
    refDivisionId: {
        label: "Division"
    },
    refGlobalStatesId: {
        label: "Status"
    },
    counterValue: {
        label: "Value"
    },
    color: {
        label: "Color"
    },
    isDefault: {
        label: "Is default"
    },
    refCodePrefixIds: {
        label: "Composition"
    }
};

export const _fr = {
    id: {
        label: "Index"
    },
    refDivisionId: {
        label: "Service"
    },
    refGlobalStatesId: {
        label: "Statut"
    },
    counterValue: {
        label: "Valeur du compteur"
    },
    color: {
        label: "Couleur"
    },
    isDefault: {
        label: "Mode de création"
    },
    refCodePrefixIds: {
        label: "Composition"
    }
};